
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casinos",
      function () {
        return require("private-next-pages/casinos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casinos"])
      });
    }
  